import { createBrowserRouter } from "react-router";
import mainRoutes from "./main-routes";

const router = createBrowserRouter([
    mainRoutes
]);

export default router;
